import React from 'react';
import { Badge } from '../../ui-kit/';

// reflect same classes/layout as in
// Schedule::Exchanges::DutyExchangeIntervalStatus enum
export const styleClasses = {
  completed: 'success',
  selected: 'primary',
  accepted: 'primary',
  pending: 'info',
  rejected: 'danger',
  no_longer_offering: 'danger'
};

// used in the UserDutyTransactionsWidget for filtering
export const allUserStates = Object.keys(styleClasses);

const TransactionUserStateLabel = props => {
  if (!props.transactionState) return null;

  const key = `classy_enum.schedule/exchanges/duty_exchange_interval_status.${props.transactionState}`;
  const translation = I18n.t(key);
  return <Badge variant={styleClasses[props.transactionState]}>{translation}</Badge>;
};

export default TransactionUserStateLabel;
